import { Tab } from "@headlessui/react";

import RowPagination from "components/General/RowPagination";
import CardRow from "components/General/CardRow";
import FormInputError from "components/General/FormInputError";
import { useRowPagination } from "hooks/useRowPagination";

import ActiveAlertView from "./ActiveAlert";
import { useTranslation } from "react-i18next";

export default function ActiveAlert({ alerts, alertError }) {
  const {
    rowsForDisplay: activeAlertRows,
    rowPaginationProps: paginationProps,
  } = useRowPagination(alerts, [5, 10, 25, "all"]);
  const { t } = useTranslation();
  if (alertError) {
    return (
      <Tab.Panel>
        <CardRow
          content={
            <FormInputError
              id="ID_activeAlertsError"
              errorMessage={t("AgentCSR-Admin-ActiveAlert-errormessage")}
            />
          }
        />
      </Tab.Panel>
    );
  }

  if (alerts?.length === 0) {
    return (
      <Tab.Panel>
        <CardRow content={t("AgentCSR-Admin-ActiveAlert-content")} />
      </Tab.Panel>
    );
  }

  return (
    <Tab.Panel>
      <>
        <div className="mt-4 mb-5 xl:mt-6 xl:mb-6">
          {activeAlertRows?.map((alert) => {
            return (
              <ActiveAlertView
                key={`active-alert-${alert?.id}`}
                alert={alert}
              />
            );
          })}
        </div>
        <RowPagination {...paginationProps} />
      </>
    </Tab.Panel>
  );
}
